import React, { useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Global from '../../store/global-selectors';
import AssignToButton from '../../components/grid-header/assign-to-button';
import * as Actions from '../../store/shipments/shipments.actions';
import { emptyArray } from 'ui-components/default-props/empty';

export const AssignToButtonContainer = () => {
  const dispatch = useDispatch();
  const users = useSelector(Global.selectSellerUsersSortedByName) || emptyArray;
  const selectedFulfillmentIds = useSelector(Global.selectSelectedShipmentsSelectedShipmentIds) || emptyArray;
  const fulfillments = useSelector((state) =>
    Global.selectEntitiesFulfillmentsByIds(state, {
      fulfillmentIds: selectedFulfillmentIds,
    }),
  );

  const fulfillmentPlanIds = useMemo(() => fulfillments.map((f) => f.fulfillmentPlanId), [fulfillments]);

  const onAssign = useCallback((selectedIds, userId) => dispatch(Actions.assignBulkFulfillmentPlanToUser(selectedIds, userId)), [dispatch]);

  return (
    <AssignToButton
      isDisabled={!fulfillmentPlanIds.length}
      onAssign={onAssign}
      selectedIds={fulfillmentPlanIds}
      supportsUnassignedOption
      users={users}
    />
  );
};
